import { AuthContext } from 'contexts/auth-context';
import moment from 'jalaali-js'


export const tree_digit_number = (text: any) => {
    if (!text) return null
    const text2 = text.toString().includes('.') ? text.toString().split(".")[0] : text.toString();
    const text3: any = text2.replace("-", "")
    const text4: any = text3.replace(",", "")
    let number: any = text4.toString().split("").reverse();
    let data2: any = [];
    for (let i = 0; i < number.length; i++) {
        if (i % 3 == 0 && i != 0) data2.unshift(number[i], ",")
        else data2.unshift(number[i])
    }
    if (text.toString().includes('.')) {
        return `${data2.join("")}.${text.toString().split(".")[1]}`
    } else {
        return data2.join("")
    }
}
export const toJalali = (date: string) => {
    if (date) {

        var ff = date.split(" ")[0];
        const d = new Date(parseInt(ff.split("-")[0]), parseInt(ff.split("-")[1]) - 1, parseInt(ff.split("-")[2]))

        return new Intl.DateTimeFormat('fa-IR').format(d)
    } else return ""
}
export const getDayNow = () => {
    
        const d = new Date()

        return new Intl.DateTimeFormat('fa-IR').format(d)
   
}
export const toJalali2 = (date: string) => {
    if (date) {
        try {

            var newDate = date.split(" ")[0];
            var newTime = date.split(" ")[1];
            const d = new Date(parseInt(newDate.split("-")[0]), parseInt(newDate.split("-")[1]) - 1, parseInt(newDate.split("-")[2]), parseInt(newTime.split(":")[0]), parseInt(newTime.split(":")[1]), parseInt(newTime.split(":")[2]))

            return new Intl.DateTimeFormat('fa-IR', { dateStyle: "medium", timeStyle: 'short' }).format(d)
        } catch (error) {
            return ""
        }
    } else return ""
}

export const getDayName = (dateStr) => {
    var convertTime = dateStr.split("")
    convertTime.splice(4, 0, '-')
    convertTime.splice(7, 0, '-')
    console.log(convertTime.join(""));

    var date = new Date(convertTime.join(""));
    return new Intl.DateTimeFormat('fa-IR').format(date)
    // return date.toLocaleDateString('fa-IR', { weekday: 'long' });        
}

export const statusSubscription = (ctx) => {


    if (ctx.user?.subscription_type == "gold")
        return "طلایی"
    if (ctx.user?.subscription_type == "silver")
        return "نقره ای"
    if (ctx.user?.subscription_type == "bronze")
        return "برنزی"

    return "پیش فرض"
}